import React from 'react';

const Share = () => {
  const url = new URL(window.location.toString());
  return (
    <>
      <button type="button" className="btn btn-label-secondary waves-effect" data-bs-toggle="modal" data-bs-target="#shareModal">
        <i className="ti ti-xs ti-share" />
        <span className="ms-2 d-none d-lg-inline">Share</span>
      </button>
      <div className="modal fade" id="shareModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Share link</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <p>
                <a href={url.toString()} className="text-secondary" target="_blank">{url.toString()}</a>
              </p>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-primary" data-bs-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export { Share };